// extracted by mini-css-extract-plugin
export default {"body":"Page_body__YjfBZ","diceContainer":"Page_diceContainer__rR5+H","dice":"Page_dice__VHM+O"};